import React from "react";
//import PDF from "react-pdf-js";

class MediaViewerPdf extends React.Component {
  constructor(props) {
    super(props);
    this.state = { currentPage: 1 };
  }

  onPrevPage() {
    const cur = this.state.currentPage;
    if (cur > 1) {
      this.setState({ currentPage: cur - 1 });
    }
  }

  onNextPage() {
    const cur = this.state.currentPage;
    if (cur < this.state.pageCount) {
      this.setState({ currentPage: cur + 1 });
    }
  }

  onDocumentComplete = pages => {
    this.setState({ pageCount: pages });
  };

  render() {
    return (
      <div id="MediaContainer">
        <div id="Media">
          {/*<PDF
            file={require("../media/Placeholder-Media-Pdf.pdf")}
            page={this.state.currentPage}
            onDocumentComplete={p => this.onDocumentComplete(p)}
          />*/}
        </div>
        <div className="PdfBtn PdfBtn-Prev" onClick={() => this.onPrevPage()}>
          <i class="fas fa-angle-left" />
        </div>
        <div className="PdfBtn PdfBtn-Next" onClick={() => this.onNextPage()}>
          <i class="fas fa-angle-right" />
        </div>
      </div>
    );
  }
}

export default MediaViewerPdf;



// WEBPACK FOOTER //
// ./src/components/MediaViewerPdf.js